export default "__VITE_ASSET__BAQvBC8q__"